import { useParams, Link, Outlet, Navigate } from 'react-router-dom';

import { useCoachActivities } from '@/data/coachActivity';
import LoadingPage from '@/components/common/LoadingPage';
import { COACH_ACTIVITY_TENANT_STATUS } from '@/app/coachActivityTenant/enums';
import NotificationDot from '@/components/common/NotificationDot';

const ActivitiesTab = () => {
  const params = useParams();
  const coachActivities = useCoachActivities(params.id);

  if (coachActivities.data.length === 0) {
    return <div>No activities found</div>;
  }

  if (!params.coachActivityId) {
    return (
      <Navigate
        to={`/coach/${params.id}/activities/${coachActivities.data[0].id}`}
      />
    );
  }

  return (
    <>
      <div className="flex gap-8 mb-2">
        {coachActivities.data.map((coachActivity) => (
          <Link
            key={coachActivity.id}
            to={`/coach/${params.id}/activities/${coachActivity.id}`}
          >
            <span
              className={`text-md font-bold py-2 transition-all duration-300 relative ${
                coachActivity.id === params.coachActivityId
                  ? 'border-b-2 border-b-primary'
                  : 'border-b-2 border-b-transparent hover:border-b-primary/30'
              }`}
            >
              {coachActivity.activity.title}
              {coachActivity.coachActivityTenants?.[0]?.status ===
                COACH_ACTIVITY_TENANT_STATUS.PENDING && <NotificationDot />}
            </span>
          </Link>
        ))}
      </div>
      <div className="py-10">
        <Outlet />
      </div>
    </>
  );
};

const ActivitiesTabLoader = () => {
  const params = useParams();
  const coachActivities = useCoachActivities(params.id);

  if (coachActivities.isLoading && !coachActivities.data) {
    return <LoadingPage />;
  }

  return <ActivitiesTab />;
};

export default ActivitiesTabLoader;
